(function () {
  "use strict";

  if (window.CartEventDatePicker) return;

  var DAY_LABELS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  var MONTH_LABELS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var activeInput = null;
  var popup = null;
  var viewMonth = 0;
  var viewYear = 0;
  var minDate = null;
  var maxDate = null;
  var popupOpenedAt = 0;
  var OUTSIDE_CLOSE_DELAY_MS = 350;
  var delegatedHandlersInstalled = false;
  var suppressNextInputFocus = false;

  function isMobileDevice() {
    return (
      window.innerWidth <= 749 ||
      (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) ||
      "ontouchstart" in window
    );
  }

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return startOfDay(result);
  }

  function formatCartEventDate(date) {
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();
    return month + "/" + day + "/" + year;
  }

  function parseCartEventDate(value) {
    if (!value || typeof value !== "string") return null;
    var parts = value.split("/");
    if (parts.length !== 3) return null;
    var month = parseInt(parts[0], 10);
    var day = parseInt(parts[1], 10);
    var year = parseInt(parts[2], 10);
    if (!month || !day || !year) return null;
    var parsed = new Date(year, month - 1, day);
    if (
      parsed.getFullYear() !== year ||
      parsed.getMonth() !== month - 1 ||
      parsed.getDate() !== day
    ) {
      return null;
    }
    return startOfDay(parsed);
  }

  function isSameDay(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  function isDisabledDate(date) {
    return date < minDate || date > maxDate;
  }

  function ensurePopup() {
    if (popup) return popup;

    popup = document.createElement("div");
    popup.className = "ff-event-date-picker";
    popup.setAttribute("role", "dialog");
    popup.setAttribute("aria-label", "Choose event date");
    popup.hidden = true;
    popup.innerHTML =
      '<div class="ff-event-date-picker__header">' +
      '<button type="button" class="ff-event-date-picker__nav ff-event-date-picker__prev" aria-label="Previous month">&lsaquo;</button>' +
      '<select class="ff-event-date-picker__month" aria-label="Month"></select>' +
      '<select class="ff-event-date-picker__year" aria-label="Year"></select>' +
      '<button type="button" class="ff-event-date-picker__nav ff-event-date-picker__next" aria-label="Next month">&rsaquo;</button>' +
      "</div>" +
      '<table class="ff-event-date-picker__grid" role="grid">' +
      "<thead><tr></tr></thead>" +
      "<tbody></tbody>" +
      "</table>";

    document.body.appendChild(popup);

    var theadRow = popup.querySelector("thead tr");
    DAY_LABELS.forEach(function (label) {
      var th = document.createElement("th");
      th.scope = "col";
      th.textContent = label;
      theadRow.appendChild(th);
    });

    popup.querySelector(".ff-event-date-picker__prev").addEventListener("click", function () {
      shiftMonth(-1);
    });
    popup.querySelector(".ff-event-date-picker__next").addEventListener("click", function () {
      shiftMonth(1);
    });
    popup.querySelector(".ff-event-date-picker__month").addEventListener("change", function (event) {
      viewMonth = parseInt(event.target.value, 10);
      renderCalendar();
    });
    popup.querySelector(".ff-event-date-picker__year").addEventListener("change", function (event) {
      viewYear = parseInt(event.target.value, 10);
      renderCalendar();
    });

    document.addEventListener("click", handleDocumentClick, true);
    document.addEventListener("keydown", handleDocumentKeyDown);
    window.addEventListener(
      "resize",
      function () {
        if (!popup.hidden && activeInput) positionPopup(activeInput);
      },
      { passive: true }
    );
    window.addEventListener(
      "scroll",
      function () {
        if (!popup.hidden && activeInput) positionPopup(activeInput);
      },
      true
    );

    return popup;
  }

  function handleDocumentClick(event) {
    if (popup.hidden) return;
    if (Date.now() - popupOpenedAt < OUTSIDE_CLOSE_DELAY_MS) return;
    if (popup.contains(event.target)) return;
    if (activeInput && (event.target === activeInput || activeInput.contains(event.target))) return;
    hidePopup();
  }

  function handleDocumentKeyDown(event) {
    if (popup.hidden) return;
    if (event.key === "Escape") {
      event.preventDefault();
      hidePopup();
      return;
    }

    var dayButton = event.target.closest
      ? event.target.closest(".ff-event-date-picker__day:not(:disabled)")
      : null;
    if (!dayButton) return;

    var offsets = {
      ArrowLeft: -1,
      ArrowRight: 1,
      ArrowUp: -7,
      ArrowDown: 7,
    };
    if (offsets[event.key] == null) return;

    event.preventDefault();
    var enabledDays = Array.from(
      popup.querySelectorAll(".ff-event-date-picker__day:not(:disabled)")
    );
    var currentIndex = enabledDays.indexOf(dayButton);
    var target = enabledDays[currentIndex + offsets[event.key]];
    if (target) target.focus();
  }

  function positionPopup(input) {
    var rect = input.getBoundingClientRect();

    if (isMobileDevice() || window.innerWidth <= 749) {
      var popupWidth = Math.min(320, window.innerWidth - 24);
      var popupLeft = Math.min(Math.max(rect.left, 12), window.innerWidth - popupWidth - 12);
      var popupTop = Math.min(rect.bottom + 4, window.innerHeight - 380);

      popup.style.position = "fixed";
      popup.style.width = popupWidth + "px";
      popup.style.top = Math.max(popupTop, 12) + "px";
      popup.style.left = popupLeft + "px";
      return;
    }

    popup.style.position = "absolute";
    popup.style.width = "";
    popup.style.top = rect.bottom + window.scrollY + 4 + "px";
    popup.style.left = rect.left + window.scrollX + "px";
  }

  function populateMonthYearSelects() {
    var monthSelect = popup.querySelector(".ff-event-date-picker__month");
    var yearSelect = popup.querySelector(".ff-event-date-picker__year");
    monthSelect.innerHTML = "";
    yearSelect.innerHTML = "";

    MONTH_LABELS.forEach(function (label, index) {
      var option = document.createElement("option");
      option.value = String(index);
      option.textContent = label;
      monthSelect.appendChild(option);
    });

    for (var year = minDate.getFullYear(); year <= maxDate.getFullYear(); year++) {
      var yearOption = document.createElement("option");
      yearOption.value = String(year);
      yearOption.textContent = String(year);
      yearSelect.appendChild(yearOption);
    }

    monthSelect.value = String(viewMonth);
    yearSelect.value = String(viewYear);
  }

  function shiftMonth(delta) {
    var next = new Date(viewYear, viewMonth + delta, 1);
    if (next < new Date(minDate.getFullYear(), minDate.getMonth(), 1)) return;
    if (next > new Date(maxDate.getFullYear(), maxDate.getMonth(), 1)) return;
    viewMonth = next.getMonth();
    viewYear = next.getFullYear();
    renderCalendar();
  }

  function renderCalendar() {
    populateMonthYearSelects();

    var tbody = popup.querySelector("tbody");
    tbody.innerHTML = "";
    var selectedDate = activeInput ? parseCartEventDate(activeInput.value) : null;
    var firstOfMonth = new Date(viewYear, viewMonth, 1);
    var startOffset = firstOfMonth.getDay();
    var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    var cellIndex = 0;

    for (var week = 0; week < 6; week++) {
      var row = document.createElement("tr");
      for (var daySlot = 0; daySlot < 7; daySlot++) {
        var cell = document.createElement("td");
        var dayNumber = cellIndex - startOffset + 1;

        if (dayNumber >= 1 && dayNumber <= daysInMonth) {
          var date = new Date(viewYear, viewMonth, dayNumber);
          var button = document.createElement("button");
          button.type = "button";
          button.className = "ff-event-date-picker__day";
          button.textContent = String(dayNumber);

          if (selectedDate && isSameDay(date, selectedDate)) {
            button.classList.add("is-selected");
          }
          if (isDisabledDate(date)) {
            button.disabled = true;
            button.classList.add("is-disabled");
          } else {
            button.addEventListener("click", function (selected) {
              return function () {
                selectDate(selected);
              };
            }(date));
          }

          cell.appendChild(button);
        }

        row.appendChild(cell);
        cellIndex++;
      }
      tbody.appendChild(row);
    }
  }

  function selectDate(date) {
    if (!activeInput || isDisabledDate(date)) return;
    activeInput.value = formatCartEventDate(date);
    activeInput.dispatchEvent(new Event("change", { bubbles: true }));
    activeInput.dispatchEvent(new Event("input", { bubbles: true }));
    hidePopup();
  }

  function showPopup(input) {
    ensurePopup();
    activeInput = input;

    var initial = parseCartEventDate(input.value) || minDate;
    if (initial < minDate) initial = minDate;
    if (initial > maxDate) initial = maxDate;
    viewMonth = initial.getMonth();
    viewYear = initial.getFullYear();

    renderCalendar();
    positionPopup(input);
    popup.hidden = false;
    popup.removeAttribute("hidden");
    popup.style.display = "block";
    popupOpenedAt = Date.now();
    input.setAttribute("aria-expanded", "true");

    var selectedDay =
      popup.querySelector(".ff-event-date-picker__day.is-selected:not(:disabled)") ||
      popup.querySelector(".ff-event-date-picker__day:not(:disabled)");
    if (selectedDay) selectedDay.focus();
  }

  function hidePopup() {
    if (!popup || popup.hidden) return;
    var inputToRestore = activeInput;
    popup.hidden = true;
    popup.style.display = "none";
    if (inputToRestore) {
      inputToRestore.setAttribute("aria-expanded", "false");
      suppressNextInputFocus = true;
      inputToRestore.focus();
    }
    activeInput = null;
  }

  function configureDateBounds(options) {
    var minDaysFromToday = options && options.minDaysFromToday != null ? options.minDaysFromToday : 1;
    var maxYears = options && options.maxYears != null ? options.maxYears : 2;

    minDate = addDays(startOfDay(new Date()), minDaysFromToday);
    maxDate = startOfDay(new Date());
    maxDate.setFullYear(maxDate.getFullYear() + maxYears);
  }

  function open(input, options) {
    if (!input) return;

    configureDateBounds(options);

    if (input.dataset.ffEventDatePickerAttached !== "true") {
      attach(input, options);
    }

    showPopup(input);
  }

  function attach(input, options) {
    if (!input || input.dataset.ffEventDatePickerAttached === "true") return;

    configureDateBounds(options);

    input.setAttribute("autocomplete", "off");
    input.setAttribute("inputmode", "none");
    input.setAttribute("aria-haspopup", "dialog");

    input.addEventListener("focus", function () {
      if (suppressNextInputFocus) {
        suppressNextInputFocus = false;
        return;
      }
      showPopup(input);
    });
    input.addEventListener("click", function () {
      showPopup(input);
    });

    if (isMobileDevice()) {
      input.addEventListener(
        "touchend",
        function (event) {
          event.preventDefault();
          showPopup(input);
        },
        { passive: false }
      );
    }

    input.dataset.ffEventDatePickerAttached = "true";
  }

  function getPickerInput(target) {
    if (!target || !target.closest) return null;

    return target.closest("#datePicker_EventDate_cart, #datePicker_EventDate_quickCart");
  }

  function handleDelegatedOpen(event) {
    var input = getPickerInput(event.target);
    if (!input) return;

    if (event.type === "touchend" || event.type === "pointerdown") {
      event.preventDefault();
    }

    open(input, {
      minDaysFromToday: 1,
      maxYears: 2,
    });
  }

  function installDelegatedOpenHandlers() {
    if (delegatedHandlersInstalled) return;

    document.addEventListener("pointerdown", handleDelegatedOpen, { capture: true, passive: false });
    document.addEventListener("mousedown", handleDelegatedOpen, true);
    document.addEventListener("click", handleDelegatedOpen, true);
    document.addEventListener("touchend", handleDelegatedOpen, { capture: true, passive: false });
    delegatedHandlersInstalled = true;
  }

  function attachQuickCartWhenVisible() {
    if (!isMobileDevice()) return;

    var input = document.getElementById("datePicker_EventDate_quickCart");
    if (!input || input.dataset.ffEventDatePickerAttached === "true") return;

    attach(input, {
      minDaysFromToday: 1,
      maxYears: 2,
    });
  }

  function watchQuickCartSidebar() {
    if (!document.body) return;

    var observer = new MutationObserver(function () {
      if (document.body.classList.contains("cart-sidebar-show")) {
        attachQuickCartWhenVisible();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  window.CartEventDatePicker = {
    attach: attach,
    open: open,
    formatCartEventDate: formatCartEventDate,
    parseCartEventDate: parseCartEventDate,
  };

  installDelegatedOpenHandlers();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchQuickCartSidebar);
  } else {
    watchQuickCartSidebar();
  }
})();
